import { DefaultPaymentMethod } from "@/services/defaultPaymentMethods/defaultPaymentMethodsService"

export const DOLLAR_PAYMENT_METHOD = 1
export const COLONES_PAYMENT_METHOD = 2
export const SINPE_MOVIL_PAYMENT_METHOD = 3
export const CREDIT_CARD_PAYMENT_METHOD = 4
export const BANK_TRANSFER_PAYMENT_METHOD = 5
export const STAFF_PAYMENT_METHOD = 6
export const EXTERNAL_ORDER_PAYMENT_METHOD = 7

export const isPosSelectablePaymentMethod = (method: {
  isActive: boolean;
  defaultPaymentMethodId?: number;
}) => method.isActive && method.defaultPaymentMethodId !== EXTERNAL_ORDER_PAYMENT_METHOD;
//only for printing
export const TRANSLATED_PAYMENT_METHOD: Record<number, string> = {
  [DOLLAR_PAYMENT_METHOD]: 'Dólares',
  [COLONES_PAYMENT_METHOD]: 'Colones',
  [SINPE_MOVIL_PAYMENT_METHOD]: 'Sinpe Móvil',
  [CREDIT_CARD_PAYMENT_METHOD]: 'Tarjeta',
  [BANK_TRANSFER_PAYMENT_METHOD]: 'Transferencia Bancaria',
  [STAFF_PAYMENT_METHOD]: 'Personal',
  [EXTERNAL_ORDER_PAYMENT_METHOD]: 'Aplicación externa',
}

export const DEFAULT_PAYMENT_METHODS: DefaultPaymentMethod[] = [
    {
      paymentMethodId: COLONES_PAYMENT_METHOD,
      name: "Colones",
      icon: "cash",
      isActive: true
    },
    {
      paymentMethodId: DOLLAR_PAYMENT_METHOD,
      name: "Dolares", 
      icon: "dollar-sign",
      isActive: true
    },
    {
      paymentMethodId: SINPE_MOVIL_PAYMENT_METHOD,
      name: "Sinpe Movil",
      icon: "smartphone", 
      isActive: true
    },
    {
      paymentMethodId: CREDIT_CARD_PAYMENT_METHOD,
      name: "Card",
      icon: "credit-card",
      isActive: true
    },
    {
      paymentMethodId: BANK_TRANSFER_PAYMENT_METHOD,
      name: "Transferencia",
      icon: "bank",
      isActive: true
    },
    {
      paymentMethodId: STAFF_PAYMENT_METHOD,
      name: "Staff",
      icon: "cash",
      isActive: true
    },
    {
      paymentMethodId: EXTERNAL_ORDER_PAYMENT_METHOD,
      name: "Aplicación externa",
      icon: "package",
      isActive: true
    }
  ]